import React, { useEffect } from "react";
import Meta from "../../components/Meta";
import QRcode from "../../components/qr_view/QR";
import { useRouter } from 'next/router';
import { useState } from 'react';

import Table from "../../components/trading/table_qr";

const Trading = () => {
    const live_version = true;
    const router = useRouter();
    const { ID } = router.query;
    const [satoshi, setSatoshi] = useState(0); // 받을 사토시
    const [sender, setSender] = useState('');
    const [message, setMessage] = useState('');
    const [lnurlw, setLNURLW] = useState('');
    const [is_used, setUsed] = useState(false);
    const [numbers, setNumbers] = useState(0);
    const [lnurlw_list, setLNURLWArray] = useState([]);
    
    // const tableData = [
    //   { column1: 'Value 1', column2: 'Value 2'},
    //   { column1: 'Value 4', column2: 'Value 5'},
    //   // Add more data rows as needed
    // ];
  


  const query_check_state = async (hash) =>{
    // const url = 'http://127.0.0.1:5001/kogods/us-central1/check_invoice_state'
    const url = live_version?'https://us-central1-kogods.cloudfunctions.net/check_invoice_state': 'http://127.0.0.1:5001/kogods/us-central1/check_invoice_state';
    const requestBody = {hash_invoice:hash}
    try {
      var response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(requestBody),
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'POST',
          'Access-Control-Allow-Headers': 'Content-Type'
        }
      })
      return response.json();
    } catch (error) {
      return {result:false};      
    }

  }

  useEffect(() => {
    console.log('numbers', numbers)
  }, [numbers]);

    useEffect(() => {
      if (ID) {
        query_check_state(ID).then(r=>{
          // amount, msg, from, lnurlw
          console.log('state hash',r)
          if(r.is_paid == 1) { // 입금완료된 것
            setSatoshi(r.amount)
            setMessage(r.msg)
            setSender(r.from)
            setLNURLW(r.lnurlw)
            if(r.numbers == 1) setUsed(r.is_used)
            else {
              setUsed(r.is_used == r.numbers)
            }
            setNumbers(r.numbers)

            var tableData = [];
            var t_obj = {};
            const len = r.lnurlw_list.length;
            for (let idx = 0; idx < r.numbers; idx++) {
              const lnurl = r.lnurlw_list[idx];
              if(idx%2 == 0) {
                t_obj = {};
                t_obj.column1 = lnurl;
              }
              else if(idx%2 == 1){
                t_obj.column2 = lnurl;
                tableData.push(t_obj);
              }
              if(r.numbers%2 == 1 && idx == r.numbers-1) {
                tableData.push(t_obj);
              }
            }
            console.log('t length',tableData.length);
            setLNURLWArray(tableData)
          }
        })
        // Update the state with the ID value
        // get info from server

      }
    }, [ID]);
  return (
    <>
      <Meta title="비트코인 기프트콘 사용" 
      desc={"비트코인, lightning network"} keyword={""}
      />

      <section className="hero relative py-20 md:pt-10">
        <div className="container">
            <h1 className="font-display text-jacarta-700 pt-16 text-center text-4xl font-medium dark:text-white">
             비트코인 받기 ⚡️⚡️ {is_used?"[사용완료]":""}
            </h1>   
            <h3 className="font-display text-jacarta-700 pt-4 text-center text-1xl font-medium dark:text-white">
                라이트닝 네트워크 지갑 앱으로 스캔하세요.
            </h3>
            <h3 className="font-display text-jacarta-700 text-center text-1xl font-medium dark:text-white">
                (wallet of satoshi, blink)
            </h3>

            {
              sender !== '' && message !== '' && (
                <h3 className="font-display text-jacarta-700 pt-2 text-center text-1xl font-medium dark:text-white">
                {sender}의 메시지: {message}
                </h3>
              )
            }

            {
              sender == '' && message !== '' && (
                <h3 className="font-display text-jacarta-700 text-center text-1xl font-medium dark:text-white">
                메시지: {message}
                </h3>
              )
            }
            <h2 className="font-display text-jacarta-700 text-center text-blue">
            기프크콘 1개당 {satoshi/numbers} SATS 
            </h2>

            {numbers==1&&!is_used&&
              <div className="mx-auto max-w-2xl pt-4" style={{ display: 'flex', justifyContent: 'center' }}>
                <QRcode text={"lightning:"+lnurlw}></QRcode>
              </div>
            }
            {numbers>1&&!is_used&&
              <div className="pt-12" style={{ display: 'flex', justifyContent: 'center' }}>
                 <Table data={lnurlw_list}></Table>
              </div>
            }
        </div>
      </section>



    </>
  );
};

export default Trading;
